import React from "react";
import { Trans } from 'react-i18next';
import {
    Button, Paragraph,
} from 'arwes';


const SignUp = () => {


    return(
        <div style={{ paddingBottom:390}}>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
                            <h2><Trans>Subscribe to receive informations via email</Trans></h2>
                        </div>
                    </div>
                    <br/>  <br/> <br/>
                    <div className="row">
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xs-offset-3 ">
                            <form id="contact-form" className="form " action="#" method="POST" role="form">
                                <div className="form-group">
                                    <Paragraph><Trans>Your Name</Trans></Paragraph>
                                    <input type="text" style={{ backgroundColor: "transparent"}} className="form-control" id="name" name="name"
                                           tabIndex="1" required/>
                                </div>
                                <div className="form-group">
                                 <Paragraph><Trans>Your Email</Trans></Paragraph>
                                    <input type="email" style={{ backgroundColor: "transparent"}} className="form-control" id="email" name="email"
                                           tabIndex="2" required/>
                                </div>


                                <div className="form-group">
                                    <Paragraph><Trans>Your favorite Category</Trans></Paragraph>
                                    <input type="email" style={{ backgroundColor: "transparent"}} className="form-control" id="email" name="email"
                                           tabIndex="2" required/>
                                </div>

                                <div className="text-center">
                                    <Button type="submit" ><Trans>Sign Up</Trans></Button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

        </div>
    )
}
export default SignUp